"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamsIntegrationModalFileListStep = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _ChannelsList = require("../ChannelsList");
var _TeamsDocGrid = require("../TeamsDocGrid");
var _UserMenu = require("../UserMenu");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TeamsIntegrationModalFileListStep = exports.TeamsIntegrationModalFileListStep = function TeamsIntegrationModalFileListStep(_ref) {
  var callbackClose = _ref.callbackClose,
    setSelectedChannel = _ref.setSelectedChannel,
    selectedChannel = _ref.selectedChannel,
    onLoadingChange = _ref.onLoadingChange;
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "70vh"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    width: "300px",
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_UserMenu.UserMenu, {
    callbackClose: callbackClose
  }), /*#__PURE__*/_react["default"].createElement(_ChannelsList.ChannelsList, {
    onSelectChannel: setSelectedChannel
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    flex: 1,
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_TeamsDocGrid.TeamsDocGrid, {
    selectedChannel: selectedChannel,
    onLoadingChange: onLoadingChange
  })));
};